import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@components/ui/Button";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: authService.login({ email, password })
    localStorage.setItem("auth_token", "dev-token");
    navigate("/");
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0B3D2E" }}>
      <form
        onSubmit={handleSubmit}
        style={{ background: "#fff", padding: 40, borderRadius: 14, width: 400, boxShadow: "0 10px 24px rgba(0,0,0,.2)" }}
      >
        <div style={{ width: 56, height: 56, borderRadius: 14, background: "#00A651", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, fontWeight: 800, marginBottom: 20 }}>
          121
        </div>
        <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>121 Insights</h1>
        <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 24 }}>Acesse sua conta para continuar</p>
        <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#374151", textTransform: "uppercase", marginBottom: 4 }}>
          E-mail
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: "100%", padding: 12, border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14, marginBottom: 16 }}
          required
        />
        <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#374151", textTransform: "uppercase", marginBottom: 4 }}>
          Senha
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: "100%", padding: 12, border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14, marginBottom: 24 }}
          required
        />
        <Button type="submit" variant="primary" block>
          Entrar
        </Button>
      </form>
    </div>
  );
}
